import React, { Component } from 'react';

// Componente nuevo: Gestión y Resultados ("Lo que Frené" / "Lo que Impulsé")
// Importante: respaldar cada punto de "Lo que Frené" con acta oficial antes de publicar
// TODO: reemplazar placeholders con hechos documentados

class GestionResultados extends Component {
    constructor(props){
        super(props);
        this.state = {
            frene: [
                {
                    id: 1,
                    texto: 'Cuestioné reasignaciones presupuestales sin justificación suficiente ante la Comisión Permanente de Hacienda.'
                },
                {
                    id: 2,
                    texto: 'Señalé subejercicios presupuestales que afectaban la atención de servicios prioritarios para la ciudadanía.'
                },
                {
                    id: 3,
                    texto: 'Solicité transparencia sobre contrataciones en la plantilla laboral municipal y su impacto en el presupuesto.'
                }
            ],
            impulse: [
                {
                    id: 1,
                    texto: 'Propuse la modificación al artículo 127 del Reglamento Interior del Ayuntamiento para fortalecer el acceso a la información pública.'
                },
                {
                    id: 2,
                    texto: 'Impulsé la priorización de recursos para alumbrado público, bacheo y mantenimiento de espacios públicos en Mineral de la Reforma.'
                },
                {
                    id: 3,
                    texto: 'Propuse fortalecer los servicios de atención psicológica y apoyo integral para las mujeres a través del Instituto Municipal de la Mujer.'
                },
                {
                    id: 4,
                    texto: 'Apliqué presupuesto basado en resultados durante mi gestión como Directora de Presupuesto en Pachuca, logrando el lugar #7 nacional en el Índice IMCO.'
                }
            ]
        }
    }

    render() {
        return (
            <section className="section-padding bg-grey" id="resultados">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading center-heading text-center mb-60">
                                <span className="subheading">Gestión y Resultados</span>
                                <h3 className="heading-title">Cada acción, con registro</h3>
                                <p>Acciones documentadas en actas de Cabildo y registros públicos.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="gestion-bloque gestion-frene">
                                <h4 className="gestion-titulo">
                                    <i className="fa fa-hand-paper me-2"></i>Lo que Frené
                                </h4>
                                <ul className="list-unstyled mt-3">
                                    {
                                        this.state.frene.map((item) => (
                                            <li key={item.id} className="gestion-item mb-3">
                                                <i className="fa fa-times-circle me-2 text-mp-gold"></i>
                                                {item.texto}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="gestion-bloque gestion-impulse">
                                <h4 className="gestion-titulo">
                                    <i className="fa fa-check-circle me-2"></i>Lo que Impulsé
                                </h4>
                                <ul className="list-unstyled mt-3">
                                    {
                                        this.state.impulse.map((item) => (
                                            <li key={item.id} className="gestion-item mb-3">
                                                <i className="fa fa-check me-2 text-mp-gold"></i>
                                                {item.texto}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default GestionResultados;
